import BaseTypesenseSearch, { ON_RENDER_INSTANTSEARCH } from '../typesense-search';


export default class SearchSection extends HTMLElement {
  constructor() {
    super();
  }

  blockSearchOnResult(totalRecords: number): void {
    const { collectionName } = this.dataset;
    const headerEl = this.querySelector('.search-section-header');
    const titleContainer = headerEl?.querySelector('h5');
    if (titleContainer) {
      titleContainer.innerHTML = `${collectionName} (${totalRecords})`;
      headerEl?.classList.add('show');
    }
  }

  init() {
    const blockSearchEl = this.querySelector('.search-block');
    if (blockSearchEl) {
      (blockSearchEl as BaseTypesenseSearch).addEventListener(ON_RENDER_INSTANTSEARCH, (evt) => {
        const nbHits = (evt as CustomEvent)?.detail?.uiState.hits?.results?.nbHits;
        if (nbHits) this.blockSearchOnResult(nbHits);
        else this.parentNode?.removeChild(this);
      });
    }
  }

  connectedCallback() {
    setTimeout(() => {
      this.init();
    });
  }
}
